import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  addClarificationAssignment,
  getEmployeeDetailsData,
  updateEmployeeStatus,
  updateRequestForClarification,
} from "./Service/EmployeeExitService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import {
  GetMasterTypeData,
} from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TostMsg } from "../../../App";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const defaultImage = "/images/placeholder_profile.png";

function EmployeeExitDetails() {
  const { ExitGUID } = useParams();
  const [Isloading, setIsloading] = useState(false);
  const [exitEmployeeList, setExitEmployeeList] = useState([]);
  const toster = useContext(TostMsg);
  const [
    setEmployeeMasterRequestClarificationData,
  ] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [visibleAssign, setVisibleAssign] = useState(false);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [selectedAssign, setSelectedAssign] = useState(false);
  const [LastWorkingDate, setLastWorkingDate] = useState("");
  const [statusData, setMasterStatusData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [exitProcessStep1, setExitProcessStep1] = useState([]);
  const [exitProcessStep2, setExitProcessStep2] = useState([]);
  const [exitProcessStep3, setExitProcessStep3] = useState([]);
  const [HowItWorkHeader, setHowItWorkHeader] = useState([]);

  useEffect(() => {
    getInitiateExitEmployeeData();
    // getMasterRequestClarificationData();
    fetchEmployeeIdData();
    getMasterExitStatus();
    GetMasterSystemAlertList();
  }, []);

  async function getInitiateExitEmployeeData() {
    const params = {
      Id: 0,
      EmpId: 0,
      Guid: ExitGUID,
      LoggedInUserId: 0,
      filterLastWorkingStartDate: "",
      filterLastWorkingEndDate: "",
      Search: "",
      Exitstatus: "",
      FnFstatus: "",
      ExitType: "",
      filterStartDate: "",
      filterEndDate: "",
      OrgId: userDetails?.OrgId,
      StatusId: 0,
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      setIsloading(true);
      const data = await getEmployeeDetailsData(params);
      let exitemployeesDetails = await data;
      setExitEmployeeList(exitemployeesDetails?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }

  async function getMasterRequestClarificationData() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "requestClarification",
    };
    try {
      setIsloading(true);
      const data = await GetMasterTypeData(params);
      let allMasterTypeData = await data.json();
      setEmployeeMasterRequestClarificationData(allMasterTypeData.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const handleToggle = () => {
    setShowOptions(!showOptions);
  };

  const handleCheckboxChange = (e, id) => {
    const { checked } = e.target;
    setSelectedOptions((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
  };

  const handleImageError = (event) => {
    event.target.src = defaultImage;
  };

  async function noDuesPendinng(ColumnName) {
    setIsloading(true);
    const params = {
      Id: 0,
      ColumnName: ColumnName,
      Value: true,
    };
    try {
      await updateRequestForClarification(params);
      if (ColumnName == "IsDue") {
        GetMasterSystemAlertList("Is_Due");
      } else if (ColumnName == "IsExitFeedback") {
        GetMasterSystemAlertList("Exit_Feedback_Request");
      } else if (ColumnName == "IsGenerateReleaseLetter") {
        GetMasterSystemAlertList("Generate_Release_Letter");
      }
      getInitiateExitEmployeeData();
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      employeeValidateList = employeesList.Data;
      setEmployeeDetails(employeeValidateList);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const handleSelectionChange = (event) => {
    setSelectedAssign(event.target.checked);
  };

  const addAssignClarification = Yup.object().shape({
    assignedUserId: Yup.string().required("Assigned userId is required"),
    categoryId: Yup.string().required("Category id is required"),
  });
  const addAssignForm = useFormik({
    initialValues: {
      assignedUserId: "",
      categoryId: "",
    },
    validationSchema: addAssignClarification,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: 0,
        EmpId: userDetails?.EmpId,
        CategoryId: data?.categoryId,
        AssignedUserId: data?.assignedUserId,
      };
      try {
        await addClarificationAssignment(body);
        GetMasterSystemAlertList("Assign_Request");
        getInitiateExitEmployeeData();
        setVisibleAssign(false);
      } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  async function GetMasterSystemAlertList(message) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message) {
        toster.current.success(msg?.Desc);
      }
 if (msg?.Name == "OrGenie_HowItWorks_Header") {
        setHowItWorkHeader(msg?.Desc);
      }
      if (msg?.Name == "Employee_ExitProcess_Step1") {
        setExitProcessStep1(msg?.Desc);
      }
      if (msg?.Name === "Employee_ExitProcess_Step2") {
        setExitProcessStep2(msg?.Desc);
      }
      if (msg?.Name === "Employee_ExitProcess_Step3") {
        setExitProcessStep3(msg?.Desc);
      }
    });
  }

  async function getMasterExitStatus() {
    const params = {
      masterType: "ExitStatus",
      organisationId: userDetails?.OrgId,
    };
    try {
      setIsloading(true);
      let masterStatusData = await GetMasterTypeData(params);
      setMasterStatusData(masterStatusData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function employeeExitLater(type) {
    let acceptType = exitEmployeeList[0]?.IsAccept;
    let declineType = exitEmployeeList[0]?.IsDecline;
    let IsWithdraw = exitEmployeeList[0]?.IsWithdraw;
    let IsFeedback = exitEmployeeList[0]?.IsExitFeedback;
    if (type == "acceptType") {
      acceptType = true;
    } else if (type == "declineType") {
      declineType = true;
    }
    try {
      const params = {
        Id: exitEmployeeList[0]?.Id,
        IsAccept: acceptType,
        IsWithdraw: IsWithdraw,
        IsDecline: declineType,
        IsFeedback: IsFeedback,
      };
      await updateEmployeeStatus(params);
      getInitiateExitEmployeeData();
      GetMasterSystemAlertList("Status Updated", 0);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  }

  return (
    <div>
      <div className="container-fluid exit-detailmodule">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Initiate Exit Details</h2>
              <p className="text-light">
                {/* View your leave balance, history, upcoming leaves, and pending requests. */}
              </p>
            </div>
          </div>
          <div className="col-xl-9">
            <div className="row card-radius">
              <div className="col-xl-12">
                <div className="card illustration-header00">
                  <div className="card-body header-meta">
                    <div className="block-header">
                      <div className="jobdetail">
                        <div className="des">
                          <div className="pro-descont">
                            <img
                              src={exitEmployeeList[0]?.ProfileImage}
                              onError={handleImageError}
                              className="rounded-circle me-2"
                              width={45}
                              alt=""
                            />
                            <div className="des-content">
                              <h4 className="block-heading">
                                {exitEmployeeList[0]?.EmployeeName || ""}
                                <span className="exit-status">
                                  {exitEmployeeList[0]?.ExitStatusName || ""}
                                </span>
                              </h4>
                              <p className="block-text">
                                <b>Employee Id</b> :{" "}
                                {exitEmployeeList[0]?.EmpId || "N/A"}{" "}
                                <span>|</span> <b>Email Id </b> :{" "}
                                {exitEmployeeList[0]?.Email || "N/A"}{" "}
                                <span>|</span> <b>Designation </b> :{" "}
                                {exitEmployeeList[0]?.CurrentDesignation ||
                                  "N/A"}{" "}
                                <span>|</span> <b>Reporting Manager </b> :{" "}
                                {exitEmployeeList[0]?.OverseerName || "N/A"}{" "}
                                <span>|</span> <b>HR Manager</b> :{" "}
                                {exitEmployeeList[0]?.HRManager || "N/A"}{" "}
                                <span>|</span> <b>Notice Days</b> :{" "}
                                {exitEmployeeList[0]?.ReportingManager || "N/A"}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <Link className="add-more" to={`/Profile/${exitEmployeeList[0]?.EmpGUID}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            fill="currentColor"
                            className="bi bi-arrow-left-short"
                            viewBox="0 0
  16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.7
  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="summary-stats">
                      <div className="summary-stat">
                        <img src="/images/pms/start-date.svg" />
                        <div>
                          <span>Initiated On</span>
                          <span>
                            {moment(exitEmployeeList[0]?.InitiatedDate).format(
                              "MMM DD YYYY"
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="summary-stat">
                        <img src="/images/pms/end-date.svg" />
                        <div>
                          <span>Business Unit</span>
                          <span>
                            {exitEmployeeList[0]?.currentbusinessunit}
                          </span>
                        </div>
                      </div>
                      <div className="summary-stat">
                        <img src="/images/pms/end-date.svg" />
                        <div>
                          <span>Exit Type</span>
                          <span>{exitEmployeeList[0]?.ExitTypeName}</span>
                        </div>
                      </div>
                      <div className="summary-stat">
                        <img src="/images/pms/end-date.svg" />
                        <div>
                          <span>FnF Status</span>
                          <span>{exitEmployeeList[0]?.FNFStatusName}</span>
                        </div>
                      </div>
                      <div className="summary-stat">
                        <img src="/images/pms/end-date.svg" />
                        <div>
                          <span>BuyOut</span>
                          <span>
                            {exitEmployeeList[0]?.IsBuyOut ? "Yes" : "No"}
                          </span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body ">
                  <div className="reason-section">
                    <strong>Reasons</strong>
                    <ul>
                      <li>
                        <b>Reason - 01 </b>
                        {exitEmployeeList[0]?.Reason1}
                      </li>
                      <li>
                        <b>Reason - 02 </b>
                        {exitEmployeeList[0]?.Reason2}
                      </li>
                    </ul>
                    <strong>Initial Comment</strong>
                    <p className="comment">{exitEmployeeList[0]?.Comment}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="fillexit-detail">
                        <div className="row">
                          <div className="col-md-4">
                            <strong>
                              Last working date                             
                              <input
                                value={
                                  exitEmployeeList[0]?.LastWorkingDate
                                    .split("T")[0]
                                }
                                onChange={(e) =>
                                  setLastWorkingDate(e.target.value)
                                }
                                className="form-control mt-2"
                                type="date"
                                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                readOnly
                                style={{color : "black"}}
                              />
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="initiate-step">
              <img
                src="https://huro.cssninja.io/assets/img/illustrations/widgets/1.svg"
                style={{ width: "160px" }}
              />
              <h4>{HowItWorkHeader}</h4>
              <ul>
                <li>
                  <span>01</span>
                  <p>{exitProcessStep1}</p>
                </li>
                <li>
                  <span>02</span>
                  <p>{exitProcessStep2}</p>
                </li>
                <li>
                  <span>03</span>
                  <p>{exitProcessStep3}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default EmployeeExitDetails;
